import { ControlProps, isDescriptionHidden } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";

import { Input } from "@/components/primitives/input";
import { InputDescription } from "@/components/primitives/InputDescription";
import FieldLabel from "@/components/primitives/InputLabel";
import InputErrorTooltip from "@/components/elements/InputErrorTooltip";

function TextControlComponent({
  data,
  handleChange,
  path,
  label,
  description,
  errors,
  schema,
  visible,
  enabled,
  required,
  config,
}: ControlProps) {
  if (!visible) return null;

  const showDescription = !isDescriptionHidden(
    visible,
    description,
    false,
    config?.showUnfocusedDescription,
  );
  const hasError = errors !== undefined && errors.length > 0;
  const placeholder =
    typeof schema.default === "string" ? schema.default : undefined;

  return (
    <div>
      <FieldLabel id={path} required={required}>
        {label}
      </FieldLabel>

      <div className="relative">
        <Input
          id={path}
          type="text"
          value={data ?? ""}
          onChange={(e) => handleChange(path, e.target.value || undefined)}
          placeholder={placeholder}
          disabled={!enabled}
          className={hasError ? "pr-12" : ""}
          maxLength={schema.maxLength}
          minLength={schema.minLength}
        />

        {hasError && (
          <span className="absolute top-1/2 right-4 w-7 -translate-y-1/2">
            <InputErrorTooltip
              iconClassNames="w-6"
              error={label + " " + errors}
            />
          </span>
        )}
      </div>

      {showDescription && description && (
        <InputDescription className="m-1">
          <span className="text-muted-foreground">{description}</span>
        </InputDescription>
      )}
    </div>
  );
}

export const TextControl = withJsonFormsControlProps(TextControlComponent);
